<template>
  <span>
    <div v-if="!showDatePicker">
      <span style="cursor: pointer;"
            @click="toggleShowDatePicker">
        <v-icon color="primary"
                style="font-size: 13px; margin-right:-2px; margin-bottom:3px;">fa fa-calendar</v-icon>&nbsp;
        <span class="primary--text"
              style="font-size:13px"
              v-html="datesString">
        </span>
        <v-icon color="primary"
                style="font-size: 16px; margin-left:-2px; margin-bottom:1px;">mdi-chevron-down</v-icon>
      </span>
      <span style="cursor: pointer;"
            @click="refresh"
            v-if="!hideRefresh">
        <v-tooltip bottom>
          <v-icon slot="activator"
                  d-inline
                  style="height:17px"
                  color="primary">mdi-refresh</v-icon>
          <span v-html="$t('global_refresh')"></span>
        </v-tooltip>
      </span>
    </div>
    <div v-else
         class="standard-font-family">
      <el-date-picker ref="datesPicker"
                      v-model="dates"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="-"
                      :start-placeholder="$t('fromLabel')"
                      :end-placeholder="$t('toLabel')"
                      :size="'mini'"
                      :format="store.state.dateFormat"
                      :picker-options="pickerOptions"
                      @blur="onDatesBlurChanged"
                      style="width: 300px;"
                      popper-class="standard-font-family">
      </el-date-picker>
    </div>
  </span>
</template>
<script>
import { Button, Dropdown } from 'element-ui';
import store from '@/store';
import moment from 'moment';
import _ from 'lodash';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

const onDatesSelectedEvent = 'on-dates-selected';

export default {
  name: 'from-to-date-selector',
  props: ['hideRefresh'],
  components: {
    [Button.Name]: Button,
    [Dropdown.Name]: Dropdown
  },
  data() {
    return {
      firstDayOfWeek: 7,
      datesTemp: [],
      dates: [
        moment()
          .startOf('month')
          .toDate(),
        moment()
          .endOf('month')
          .toDate()
      ],
      showDatePicker: false,
      store: store,
      datesString: '',
      pickerOptions: {
        firstDayOfWeek: 7,
        shortcuts: [
          {
            text: this.$i18n.t('todayRangeLabel'),
            onClick(picker) {
              const start = moment()
                .startOf('day')
                .toDate();
              const end = moment()
                .endOf('day')
                .toDate();
              picker.$emit('pick', [start, end]);
            },
            i18nText: 'todayRangeLabel'
          },
          {
            text: this.$i18n.t('thisweekRangeLabel'),
            onClick(picker) {
              const start = moment()
                .startOf('week')
                .toDate();
              const end = moment()
                .endOf('week')
                .toDate();
              picker.$emit('pick', [start, end]);
            },
            i18nText: 'thisweekRangeLabel'
          },
          {
            text: this.$i18n.t('thismonthRangeLabel'),
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            },
            i18nText: 'thismonthRangeLabel'
          },
          {
            text: this.$i18n.t('lastmonthRangeLabel'),
            onClick(picker) {
              const start = moment()
                .subtract(1, 'month')
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract(1, 'month')
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            },
            i18nText: 'lastmonthRangeLabel'
          }
        ]
      }
    };
  },
  created() {
    this.updateDatesString();
    EventBus.$on(keys.eventOnLanguageChanged, this.updateDatesString);
    this.refresh();
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateDatesString);
  },
  methods: {
    updateDatesString() {
      this.datesString = `${moment(this.dates[0]).format('L')} <i class="ion-arrow-right-c"></i> ${moment(this.dates[1]).format('L')}`;

      _.each(this.pickerOptions.shortcuts, itShortcut => {
        itShortcut.text = this.$i18n.t(itShortcut.i18nText);
      });

      this.pickerOptions.firstDayOfWeek = store.state.langSelected.firstDayOfWeek;
    },
    onDatesBlurChanged(datesSelection) {
      this.toggleShowDatePicker();
      if (datesSelection === null) {
        this.$nextTick(() => {
          this.dates = this.datesTemp;
        });
        return;
      } else {
        if (datesSelection[0] === this.dates[0] && datesSelection[1] === this.dates[1]) {
          return;
        }
      }
      this.updateDatesString();
      this.refresh();
    },
    toggleShowDatePicker() {
      this.showDatePicker = !this.showDatePicker;
      if (this.showDatePicker) {
        this.datesTemp = this.dates;
        this.$nextTick(() => {
          this.$refs.datesPicker.$el.children[1].focus();
        });
      }
    },
    refresh() {
      this.dates[1] = moment(this.dates[1])
        .endOf('day')
        .toDate();
      this.$emit(onDatesSelectedEvent, this.dates);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/commons/FromToDateSelector.vue